import { useState, useEffect } from "react";
import { useAuth } from "@clerk/react";
import type { BillingStatus, Plan } from "@tuit/shared-types";
export type { Plan };
import { getBillingStatus } from "../api.js";

let cache: BillingStatus | null = null;

export function useBillingStatus() {
  const { isSignedIn } = useAuth();
  const [status, setStatus] = useState<BillingStatus | null>(cache);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    if (!isSignedIn) return;
    if (cache) { setStatus(cache); setLoading(false); return; }
    getBillingStatus()
      .then((s) => { cache = s; setStatus(s); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [isSignedIn]);

  function invalidate() {
    cache = null;
    setLoading(true);
    getBillingStatus()
      .then((s) => { cache = s; setStatus(s); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }

  return { status, loading, invalidate };
}
